<template></template>

<script>
  import { navigator } from 'window'
  import notyMixin from '@/helpers/noty'
  import { networkChangedNotification } from './notifications'

  export default {
    mixins: [
      notyMixin
    ],
    data () {
      return {
        networkType: navigator.connection.type
      }
    },
    watch: {
      networkType (to, from) {
        if (from !== 'none') {
          this.$_notificationsToCloseOnDestroy.push(
            networkChangedNotification().show()
          )
        }
      }
    },
    beforeDestroy () {
      navigator.connection.removeEventListener('change', this.handleNetworkChange)
    },
    mounted () {
      navigator.connection.addEventListener('change', this.handleNetworkChange)
    },
    methods: {
      handleNetworkChange () {
        const networkInfo = navigator.connection
        this.networkType = networkInfo.type
        console.log('[NetworkChange]', this.serialize(networkInfo))
      },
      serialize (networkInfo) {
        const serializedNetworkInfo = {}

        const properties = [
          'downlink',
          'downlinkMax',
          'effectiveType',
          'rtt',
          'saveData',
          'type'
        ]

        properties.forEach(property => (serializedNetworkInfo[property] = networkInfo[property]))
        return serializedNetworkInfo
      }
    }
  }
</script>




// WEBPACK FOOTER //
// network-change-detector.vue?88faf298